import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { BodyText, theme } from '@sweetgreen/garnish';

export const MenuHeaderTitle = ({
  label,
  locationName,
  estimateHeader,
  onPress,
}: MenuHeaderTitleProps) => {
  if (locationName === undefined) {
    return null;
  }

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={[label, locationName].filter(Boolean).join(' ')}
      onPress={onPress}
    >
      {label ? (
        <BodyText size={2} style={styles.headerNavbarTitle}>
          {label}
        </BodyText>
      ) : null}

      <View style={styles.headerRow}>
        <BodyText
          size={2}
          style={[styles.headerNavbarTitle, styles.headerNavbarRestaurantName]}
          underline
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {locationName}
        </BodyText>

        {estimateHeader ? (
          <BodyText
            size={2}
            style={[styles.headerNavbarTitle, styles.headerNavbarEstimatedText]}
          >
            {estimateHeader}
          </BodyText>
        ) : null}
      </View>
    </Pressable>
  );
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type MenuHeaderTitleProps = {
  readonly label?: string;
  readonly locationName?: string;
  readonly estimateHeader?: string;
  readonly onPress?: () => void;
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerNavbarTitle: {
    flexShrink: 1,
    textAlign: 'center',
  },
  headerNavbarEstimatedText: {
    marginLeft: theme.spacing.xsmall,
  },
  headerNavbarRestaurantName: {
    color: theme.colors.KALE,
  },
});
